import { Checkbox as MuiCheckbox } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const CheckboxStyled = styled(MuiCheckbox, shouldNotForwardProps('heightEqualsInput'))(({ heightEqualsInput }) => ({
    ...(heightEqualsInput && {
        paddingTop: '.25rem',
        paddingBottom: '.25rem',
    }),
}));
